var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Card, Col, TextField } from '@folio/stripes/components';
import React from 'react';
import { Field, useField } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';
import { CriteriaGroupType, CriteriaTerminalType } from '../../../types';
import ConditionalCard from '../../ConditionalCard';
import css from '../TokenStyles.module.css';
export default function ConstantConditionalToken(_a) {
    var prefix = _a.prefix;
    var aggregate = useField('aggregate', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    return (React.createElement(FieldArray, { name: "".concat(prefix, "conditions"), defaultValue: [{ type: CriteriaTerminalType.PATRON_GROUP }] }, function (_a) {
        var fields = _a.fields;
        return (React.createElement(React.Fragment, null,
            React.createElement(Col, { xs: 12 }, fields.map(function (name, index) { return (React.createElement(ConditionalCard, { key: name, index: index, conditionName: name, patronOnly: aggregate, fieldArrayName: "".concat(prefix, "conditions") },
                React.createElement(Field, { name: "".concat(name, ".value") }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.token.constantConditional.value" }) }))); }))); })),
            React.createElement(Col, { xs: 12 },
                React.createElement(Card, { headerStart: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.otherwise" }) },
                    React.createElement(Field, { name: "".concat(prefix, "else") }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.token.fallback" }) }))); }))),
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { onClick: function () { return fields.push({ type: CriteriaGroupType.ALL_OF }); } },
                    React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.button.addCondition" })),
                React.createElement("p", { className: css.noMargin },
                    React.createElement("i", null,
                        React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.token.constantConditional.description" }))))));
    }));
}
